'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _PaperClipOutlined = _interopRequireDefault(require('./lib/icons/PaperClipOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _PaperClipOutlined;
exports.default = _default;
module.exports = _default;